import { Component, inject, Injector } from '@angular/core';
import { Router } from "@angular/router";

import { AuthService } from "../../auth/auth.service";
import { SessionService } from "../../services/session.service";

@Component({
    selector: 'navbar-top',
    templateUrl: './navbar-top.component.html',
    standalone: false
})

export class NavbarTopComponent {
  injector = inject(Injector);
  authService = inject(AuthService);
  session = inject(SessionService);
  router = inject(Router);

  constructor (
  ) { };

  hamburgerOnClick () {
    this.session.menuMobileLeftVisible = !this.session.menuMobileLeftVisible;
    this.session.menuMobileCenterVisible = false;
    this.session.menuMobileRightVisible = false;

    if (!this.session.race && this.session.isMobileDevice) {
      this.session.setAlertMessage("Please select a race");
    };
  };

  centerOnClick () {
    this.session.menuMobileCenterVisible = !this.session.menuMobileCenterVisible;
    this.session.menuMobileLeftVisible = false;
    this.session.menuMobileRightVisible = false;
  };

  rightOnClick () {
    this.session.menuMobileRightVisible = !this.session.menuMobileRightVisible;
    this.session.menuMobileLeftVisible = false;
    this.session.menuMobileCenterVisible = false;
  };
};
